import { type Overrides } from '@material-ui/core/styles/overrides';

const overrides: Overrides = {
	MuiButton: {
		root: {
			fontWeight: 500,
			borderRadius: 4,
		},
	},
	MuiPaper: {
		elevation1: {
			boxShadow: '0px 2px 2px rgba(117, 139, 183, 0.1) !important',
			border: '1px solid #E2E8F0 !important',
		},
	},
	MuiFormLabel: {
		root: {
			fontSize: 14,
			fontWeight: 500,
			marginBottom: 8,
		},
	},
};

export default overrides;
